module.exports = __webpack_public_path__ + "media/images/img_point1-4220a5c2e85ef2a09113381c82b2e665.jpg";